import React, { useState, useEffect } from 'react';
import { Container, HoverDiv, ListWrapper, ArrowButton } from './styles';
import Button from '../../components/Buttom/Button';
import IDestination from 'interfaces/IDestination';
import { useHistory } from 'react-router';
import SubTitle from 'common/SubTitle/SubTitle';

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [matches, query]);

  return matches;
};

interface Props {
  destinations?: IDestination[];
}

const ITEMS_PER_PAGE = 4;

const Destinations = (props: Props): JSX.Element => {
  const { destinations } = props;
  const history = useHistory();
  const [currentIndex, setCurrentIndex] = useState(0);

  const isMobile = useMediaQuery('(max-width: 980px)');

  const defaultCharacteristics = [
    'LINDAS PRAIAS E CLIMA TRANQUILO',
    'VARIEDADE GASTRONÔMICA',
    'PASSEIOS DE QUADRICICLO, BARCO E MERGULHO COM CILINDRO',
    'CENTRO HISTÓRICO',
  ];

  const handlePrev = () => {
    if (!destinations) return;
    const newIndex = currentIndex - ITEMS_PER_PAGE;
    if (newIndex < 0) {
      const totalPages = Math.ceil(destinations.length / ITEMS_PER_PAGE);
      const lastPageIndex = (totalPages - 1) * ITEMS_PER_PAGE;
      setCurrentIndex(lastPageIndex);
    } else {
      setCurrentIndex(newIndex);
    }
  };

  const handleNext = () => {
    if (!destinations) return;
    const newIndex = currentIndex + ITEMS_PER_PAGE;
    if (newIndex >= destinations.length) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(newIndex);
    }
  };

  const destinationsToShow = isMobile ? destinations : destinations?.slice(currentIndex, currentIndex + ITEMS_PER_PAGE);

  const showArrows = !isMobile && destinations && destinations.length > ITEMS_PER_PAGE;

  return (
    <Container>
      <SubTitle text="Conheça Nossos Corredores Turísticos" />

      <ListWrapper>
        {showArrows && (
          <>
            <ArrowButton onClick={handlePrev}>&lt;</ArrowButton>
            <ArrowButton onClick={handleNext}>&gt;</ArrowButton>
          </>
        )}

        <ul>
          {destinationsToShow?.map(destination => {
            return (
              <li
                key={destination.id}
                style={{ background: `url(${destination.image}) center center / cover no-repeat` }}>
                <Button text={destination.title} onClick={() => history.push(`destinations/${destination.slug}`)} />
                <HoverDiv>
                  {(destination.characteristics || defaultCharacteristics).slice(0, 5).map((characteristic, key) => (
                    <span key={key}>{characteristic}</span>
                  ))}
                  <Button
                    text={`CONHEÇA ${destination.title.toUpperCase()}`}
                    onClick={() => history.push(`destinations/${destination.slug}`)}
                  />
                </HoverDiv>
              </li>
            );
          })}
        </ul>
      </ListWrapper>

      {/* <Button text="conheça nossos destinos" onClick={() => history.push('destinations')} /> */}
    </Container>
  );
};

export default Destinations;
